import {ChangeDetectorRef, Component, ElementRef, HostListener, Input, OnInit, ViewChild} from '@angular/core';
import {ExcTranslation} from 'exc-core-v2';
import {EnumerationService} from '../../services/enumeration.service';
import {ExgTextareaInputComponent} from '../../misc/exg-textarea-input/exg-textarea-input.component';

@Component({
  selector: 'app-annotation-text',
  templateUrl: './annotation-text.component.html',
})
export class AnnotationTextComponent extends ExcTranslation implements OnInit {
  @Input()
  note?: any;
  @Input()
  mode = 'note';
  @Input()
  init = false;

  refText = false;
  values = {
    rcptNtsRefText: '',
    rcptNtsNote: ''
  };
  @ViewChild('VCNodeText', {read: ExgTextareaInputComponent}) VCNodeText!: ExgTextareaInputComponent;
  @ViewChild('VCNodeText', {read: ElementRef}) elementNodeText!: ElementRef;
  valuesClone: any;

  @HostListener('document:keypress', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent): void {
    this.chDecRef.markForCheck();
  }

  constructor(
    private chDecRef: ChangeDetectorRef,
    public enumSvc: EnumerationService) {
    super();
  }

  ngOnInit(): void {
    this.initialize();
  }


  initialize(): void {
    if (this.note !== undefined) {
      this.init = !!this.note.init;

      if (this.mode !== 'note') {
        this.values.rcptNtsRefText = 'Selection';
      }
      if (!this.init) {
        this.values.rcptNtsNote = this.note.rcptNtsNote;
        this.values.rcptNtsRefText = this.note.rcptNtsRefText;
      }
    } else {
      this.init = true;
      this.note = {
        rcptNtsRefText: '',
        rcptNtsNote: ''
      };
    }
    this.valuesClone = this.clone(this.values);
  }

  getValues(): any {
    this.values.rcptNtsNote = this.VCNodeText.value;
    return this.values;
  }

  clone(cloneObj: any): any {
    return JSON.parse(JSON.stringify(cloneObj));
  }

  setDefaultFocus(): void {
    (this.elementNodeText.nativeElement.children[0].children[0]).focus();
  }
}
